module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalAjoutAbsenceImposeeContrat"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "756px",
      "min-width": "756px"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "body color"
  }, [_c('div', {
    staticClass: "table-mode"
  }, [_c('div', {
    staticClass: "inp-table noselect d-inline-block"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th cln-check center-flex",
    attrs: {
      "title": "Tout sélectionner"
    }
  }, [_c('div', {
    staticClass: "inp-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "selectAll",
      "checked": ""
    },
    on: {
      "change": function($event) {
        _vm.selectAll($event)
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "tbody tw-max-h-[340px]"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.salaries), function(salarie) {
    return _c('div', {
      staticClass: "tr",
      attrs: {
        "data-testid": "planningAbsence-absenceCollective-chooseEmployeesModal-table"
      }
    }, [_c('div', {
      staticClass: "td cln-check center-flex"
    }, [_c('div', {
      staticClass: "inp-checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'select' + salarie.IdSalarie
      },
      domProps: {
        "checked": _vm.ischecked(salarie.IdSalarie)
      },
      on: {
        "change": function($event) {
          _vm.select($event, salarie)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'select' + salarie.IdSalarie
      }
    }, [_c('span', {
      staticClass: "ml-2"
    }, [_vm._v("Tout sélectionner")])])])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nom"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(salarie.FullName) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nsalarie"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(salarie.NumeroSalarie) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-ncontrat"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(salarie.NumeroContrat) + "\n\t\t\t\t\t\t\t\t\t\t")])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-custom mt-3 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "tw-cursor-pointer tw-flex tw-gap-1",
    on: {
      "click": function($event) {
        _vm.toggleEnvoiEMail()
      }
    }
  }, [_c('span', {
    staticClass: "fa-solid tw-duration-200 tw-text-3xl",
    class: _vm.envoyerEMailSalaries ? 'fa-toggle-on tw-text-sky-500' : 'fa-toggle-off tw-text-gray-500'
  }), _vm._v(" "), _c('span', {
    staticClass: "tw-text-lg tw-pt-0.5"
  }, [_vm._v("Notifier les salariés par e-mail")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer mt-5 pr-0"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_vm._m(6), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("CHOISIR UN OU PLUSIEURS CONTRATS")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "selectAll"
    }
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Tout sélectionner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-nom",
    attrs: {
      "title": "NOM / PRÉNOM"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("NOM / PRÉNOM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-nsalarie",
    attrs: {
      "title": "N° SALARIÉ"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N° SALARIÉ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th cln-ncontrat",
    attrs: {
      "title": "N° CONTRAT"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N° CONTRAT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-salarie"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nsalarie"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-ncontrat"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit",
      "data-testid": "planningAbsence-absenceCollective-chooseEmployeesModal-validate-button"
    }
  }, [_c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a41994"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/planningAbsences/modalAjoutAbsenceImposeeContrat/modalAjoutAbsenceImposeeContrat.vue.html
// module id = C5GQ
// module chunks = 2